import { FaPlus, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import localeInfo from "rc-pagination/lib/locale/en_US";
import { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  Table,
  OverlayTrigger,
  Tooltip,
  Form,
} from "react-bootstrap";
import { useListEventsQuery, useDeleteEventMutation } from "../../redux/api";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { ENV } from "../../config/config";
import { useGetRoleQuery } from "../../redux/api";
import Select from "react-select";
import moment from "moment";

var CryptoJS = require("crypto-js");

const Events = (props) => {
  const [data, setData] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [resetButton, setResetButton] = useState(false);
  const [permissions, setPermissions] = useState({});
  const [filters, setFilters] = useState({
    title: "",
    status: "",
  });
  const statusOptions = [
    { value: "Published", label: "Published" },
    { value: "Draft", label: "Draft" },
    { value: "Inactive", label: "Inactive" },
  ];

  const [qs, setQs] = useState("");
  const { data: eventsData, isLoading: isEventsLoading, isFetching: isEventsFetching, refetch } = useListEventsQuery(qs);
  const [deleteEventMut, { isLoading: isDeletingEvent }] = useDeleteEventMutation();
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const roleEncrypted = localStorage.getItem("role");
  const roleDecrypted = roleEncrypted
    ? CryptoJS.AES.decrypt(roleEncrypted, ENV.secretKey).toString(
        CryptoJS.enc.Utf8
      )
    : "";
  const { data: roleData, isLoading: isRoleLoading, isFetching: isRoleFetching } = useGetRoleQuery(roleDecrypted, { skip: !roleEncrypted });

  const isGlobalLoading = isEventsLoading || isEventsFetching || isRoleLoading || isRoleFetching || isDeletingEvent;

  useEffect(() => {
    if (roleData && roleData.role?.permissions) {
            if (typeof roleData.role.permissions === 'string') {
                setPermissions(JSON.parse(roleData.role.permissions));
            } else {
                setPermissions(roleData.role.permissions);
            }
    }
  }, [roleData]);

  useEffect(() => {
    if (eventsData) {
      setData(eventsData.events);
      setPagination(eventsData.pagination);
    }
  }, [eventsData]);

  useEffect(() => {}, []);

  const deleteEvent = (id) => {
    Swal.fire({
      title: "Are you sure you want to delete?",
      html: "If you delete an item, it will lost permanently.",
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then(async (result) => {
      if (result.value) {
        deleteEventMut(id).then(() => {
          const nextQs = ENV.objectToQueryString({ page: 1, limit: 10, ...filters });
          setQs(nextQs);
          refetch();
        });
      }
    });
  };

  const onPageChange = async (page) => {
    const nextQs = ENV.objectToQueryString({ page, ...filters });
    setQs(nextQs);
  };

  const applyFilters = () => {
    if ((filters && filters.title) || (filters && filters.status)) {
      setResetButton(true);
      const nextQs = ENV.objectToQueryString({ page: 1, limit: 10, ...filters });
      setQs(nextQs);
    } else {
      toast.error("All filter fields are empty.", {
        toastId: "FIELD_REQUIRED",
      });
    }
  };

  const reset = () => {
    setResetButton(false);
    setFilters({ title: "", status: "" });
    setQs("");
  };

  if (isGlobalLoading) {
    return <FullPageLoader />;
  }

  return (
    <>
        <Container fluid>
          <Row className="pb-3">
            <Col sm={12}>
              <Card className="filter-card">
                <Card.Header>
                  <div className="d-flex align-items-center justify-content-between table-head">
                    <Card.Title as="h4">Filters</Card.Title>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col xl={4} sm={6}>
                      <Form.Group>
                        <label>Search with Title...</label>
                        <Form.Control
                          value={filters.title}
                          type="text"
                          placeholder="Title"
                          onChange={(e) =>
                            setFilters({
                              ...filters,
                              title: e.target.value.trim(),
                            })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} sm={6} className="search-wrap">
                      <label>Search with status...</label>
                      <Form.Group>
                        <Select
                          classNamePrefix="triage-select"
                          placeholder="Select Status"
                          className="w-100"
                          options={statusOptions}
                          onChange={(e) =>
                            setFilters({
                              ...filters,
                              status: e ? e.value : "",
                            })
                          }
                          value={statusOptions.filter(
                            (s) => s.value === filters.status
                          )}
                          isClearable
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} md={6}>
                      <Form.Group>
                        <Form.Label className="d-block mb-2">&nbsp;</Form.Label>
                        <div className="d-flex  filter-btns-holder">
                          <Button
                            className="btn-filled mr-3"
                            onClick={applyFilters}
                          >
                            Search
                          </Button>
                          {resetButton && (
                            <Button
                              variant="warning"
                              className="outline-button"
                              onClick={reset}
                            >
                              Reset
                            </Button>
                          )}
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Card className="table-big-boy">
                <Card.Header>
                  <div className="d-flex align-items-center justify-content-between table-head">
                    <Card.Title as="h4">Events</Card.Title>
                    {permissions && permissions.addEvent && (
                      <Button
                        className="float-sm-right btn-filled d-flex align-items-center"
                        onClick={() => props.history.push(`/add-event`)}
                      >
                        <span className="add-icon mr-2">
                          <FaPlus />
                        </span>
                        Add Event
                      </Button>
                    )}
                  </div>
                </Card.Header>
                <Card.Body className="table-full-width">
                  <div className="table-responsive">
                    <Table className="table-bigboy table-w cms-table">
                      <thead>
                        <tr>
                          <th className="td-start serial-col">#</th>
                          <th className="td-status">Image</th>
                          <th className="td-name">
                            <div className="faqs-title td-name">Title</div>
                          </th>
                          <th className="td-name">
                            <div className="faqs-title td-name">Event Date</div>
                          </th>
                          <th className="td-status text-center">Status</th>
                          {(permissions?.editEvent ||
                            permissions?.deleteEvent) && (
                            <th className="td-actions text-center">Actions</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {data && data.length ? (
                          data.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td className="serial-col">
                                  {pagination &&
                                    pagination.limit * pagination.page -
                                      pagination.limit +
                                      index +
                                      1}
                                </td>
                                <td>
                                  <img
                                    src={
                                      ENV.assetsUrl +
                                      "gallery/" +
                                      item?.imageUrl
                                    }
                                    id="imageUploader"
                                    className="image-fluid"
                                    style={{ width: "30%", height: "30%" }}
                                    alt="gallery-image"
                                  />
                                </td>
                                <td>
                                  <div className="faq-title td-name">
                                    {item.title}
                                  </div>
                                </td>
                                <td>
                                  <div className="faq-title td-name">
                                    {moment(item?.eventDate).format("MMM DD, YYYY")}
                                  </div>
                                </td>
                                <td className="text-center">
                                  <span
                                    className={`label kyc-badge kyc-status-badge d-inline-block align-top px-2 py-1 ${
                                      item.status === "Published"
                                        ? "label-success"
                                        : item.status === "Inactive" ? "label-danger" : "label-warning"
                                    }`}
                                  >
                                    {item.status}
                                  </span>
                                </td>
                                {(permissions?.editEvent ||
                                  permissions?.viewEvent ||
                                  permissions?.deleteEvent) && (
                                  <td className="td-actions">
                                    <ul className="list-unstyled mb-0 d-flex justify-content-center align-items-center">
                                      {permissions?.viewEvent && (
                                        <li className="d-inline-block align-top">
                                          <OverlayTrigger
                                            overlay={
                                              <Tooltip id="tooltip-436082023">
                                                {" "}
                                                View{" "}
                                              </Tooltip>
                                            }
                                            placement="left"
                                          >
                                            <Button
                                              className="btn-link btn-icon"
                                              type="button"
                                              variant="info"
                                              onClick={() =>
                                                window.open(
                                                  `${ENV.frontendUrl}events/${item.url}`,
                                                  "_blank"
                                                )
                                              }
                                            >
                                              <FaEye />
                                            </Button>
                                          </OverlayTrigger>
                                        </li>
                                      )}
                                      {permissions && permissions.editEvent && (
                                        <li className="d-inline-block align-top">
                                          <OverlayTrigger
                                            overlay={
                                              <Tooltip id="tooltip-436082023">
                                                {" "}
                                                Edit{" "}
                                              </Tooltip>
                                            }
                                            placement="left"
                                          >
                                            <Button
                                              className="btn-link btn-icon"
                                              type="button"
                                              variant="success"
                                              onClick={() =>
                                                props.history.push(
                                                  `/edit-event/${window.btoa(
                                                    item.id
                                                  )}`
                                                )
                                              }
                                            >
                                              <FaEdit />
                                            </Button>
                                          </OverlayTrigger>
                                        </li>
                                      )}
                                      {permissions &&
                                        permissions.deleteEvent && (
                                          <li className="d-inline-block align-top">
                                            <OverlayTrigger
                                              overlay={
                                                <Tooltip id="tooltip-334669391">
                                                  {" "}
                                                  Delete{" "}
                                                </Tooltip>
                                              }
                                              placement="left"
                                            >
                                              <Button
                                                className="btn-link btn-icon"
                                                type="button"
                                                variant="danger"
                                                disabled={isDeletingEvent}
                                                onClick={() =>
                                                  deleteEvent(item.id)
                                                }
                                              >
                                                <FaTrash />
                                              </Button>
                                            </OverlayTrigger>
                                          </li>
                                        )}
                                    </ul>
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              <div className="alert alert-info" role="alert">
                                No Event Found
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    {pagination && (
                      <Pagination
                        className="m-3"
                        defaultCurrent={1}
                        pageSize // items per page
                        current={pagination.page} // current active page
                        total={pagination.pages} // total pages
                        onChange={onPageChange}
                        locale={localeInfo}
                      />
                    )}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
    </>

  );
};

export default Events;
 
